/**
 * Validates the object at the given path.
 * @param   {Object} payload
 *          {string} payload.path
 *          {Object} [payload.options]
 * @param   {*} value
 * @returns {Object[]|null}
 */
import validatorUtil from 'modules/redux/validators'
import REDUX_OPTION from 'modules/redux/constants/option'

function validateReduxUtil (instance, options) {
  const { className, changed } = instance
  options = options || {}
  const keysToValidate = (
    options[REDUX_OPTION.KEYS_TO_VALIDATE] || Object.keys(changed)
  )
  // Validate every key of the given `data`
  let validation
  keysToValidate.every(key => {
    const validator = validatorUtil({
      key,
      className
    })
    let validationVal
    if (validator) {
      const value = changed[key]
      validationVal = validator(value, { instance })
    }
    if (validationVal && validationVal !== true) {
      validation = validationVal
    }
    return validation == null
  })
  return validation
}

export default validateReduxUtil
